import { useRouter } from "next/router";
import React, { useCallback, useEffect } from "react";

import FilterSkeleton from "../loading-skeleton/FilterSkeleton";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import { FilterAsCheckbox } from "./FilterAsCheckbox";
import getFilterLabel from "./getFilterLabel";

let timer;

const BatteryGradeFacet = ({
  filteredSubfilters,
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
}) => {
  const hasBatteryHealthReport = appliedCheckboxes.find(
    (item) =>
      (item.categoryKey === "HasBatteryHealthReport" ||
        item.categoryKey === "hasbatteryhealthreport") &&
      item.filterKey === "true"
  );

  const router = useRouter();

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [stringifiedFilters, appliedCheckboxes, router]);

  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onChange = (categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;

    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: "true",
          categoryKey: "HasBatteryHealthReport",
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  const filterCount = filteredSubfilters?.find((item) => {
    return item.filterKey === "Yes";
  })?.filterValues[0].count;

  return (
    <>
      {!filteredSubfilters && <FilterSkeleton pairCount={2} />}
      <FilterAsCheckbox
        key={hasBatteryHealthReport?.filterKey}
        id={hasBatteryHealthReport?.filterKey}
        label={getFilterLabel("HasBatteryHealthReport", "true")}
        isSelected={Boolean(hasBatteryHealthReport?.filterKey)}
        onChange={() => onChange("HasBatteryHealthReport")}
        resultsCount={filterCount}
      />
    </>
  );
};

export default BatteryGradeFacet;
